import React from "react";
import { FaRegHandPointRight } from "react-icons/fa";

const Section = ({ title, links }) => (
  <div style={{ marginBottom: "40px" }}>
    
    {/* Section Heading */}
    <h3
      style={{
        textAlign: "center",
        fontWeight: "700",
        fontSize: "17px",
        letterSpacing: "1px",
        marginBottom: "22px",
        color: "#2b2b2b",
        
      }}
    >
      {title}
    </h3>

    {/* Links List */}
    <div style={{ paddingLeft: "45px" }}>
      {links.map((item, index) => (
        <div
          key={index}
          style={{
            display: "flex",
            alignItems: "center",
            marginBottom: "12px",
            fontSize: "15px",
            color: "#444"
          }}
        >
          <FaRegHandPointRight 
            style={{ marginRight: "12px", fontSize: "13px", color: "#555" }} 
          />

          <a
            href={item.url}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              textDecoration: "none",
              color: "#444",
              transition: "0.3s"
            }}
            onMouseOver={(e) => (e.target.style.color = "#1f5c8b")}
            onMouseOut={(e) => (e.target.style.color = "#444")}
          >
            {item.name}
          </a>
        </div>
      ))}
    </div>
  </div>
);

export default function ImportantLinks() {
  return (
    <div
      style={{
        background: "#f5f6f7",   // 🔥 main background exact feel
        padding: "30px 0",
        fontFamily: "Arial, sans-serif"
      }}
    >
      {/* TOP TITLE BOX */}
     {/* TOP TITLE BOX */}
<div
  style={{
    width: "85%",
    margin: "20px auto 30px",
    background: "#f0f7ff",   // 🔥 exact bluish grey
    borderRadius: "10px",
    padding: "14px 8px",
    textAlign: "center",
    border: "1px solid #b8c2cc",
    boxShadow: "0 2px 4px rgba(0,0,0,0.08)"
  }}
>
  <h2
    style={{
      margin: 0,
      color: "#1f4a7a",      // 🔥 exact dark blue
      fontSize: "22px",      // 🔥 bigger like screenshot
      fontWeight: "700",
      letterSpacing: "1.5px",
      fontFamily: "Arial, Helvetica, sans-serif"
    }}
  >
    IMPORTANT LINKS
  </h2>
</div>

      <div style={{ width: "90%", margin: "0 auto" }}>
        
        {/* SECTION 1 */}
        <Section
          title="PROFESSIONAL INSTITUTIONS/BODIES"
          links={[
            { name: "Institute of Chartered Accountants of India (ICAI)", url: "https://www.icai.org" },
            { name: "Northern India Regional Council of ICAI (NIRC)", url: "https://nirc-icai.org" },
            { name: "Central India Regional Council of ICAI (CIRC)", url: "https://circ.icai.org" },
            { name: "Eastern India Regional Council of ICAI (EIRC)", url: "https://eirc-icai.org" },
            { name: "Southern India Regional Council of ICAI (SIRC)", url: "https://sircoficai.org" },
            { name: "Western India Regional Council of ICAI (WIRC)", url: "https://wirc-icai.org" },
            { name: "Institute of Company Secretaries of India", url: "https://www.icsi.edu" },
            { name: "Northern India Regional Council of ICSI (NIRC)", url: "https://nirc-icsi.org" },
            { name: "Western India Regional Council of ICSI (WIRC)", url: "https://wirc-icsi.org" },
            { name: "Institute of Cost Accountants of India", url: "https://icmai.in" },
            { name: "Bombay Chartered Accountants Society", url: "https://bcasonline.org" },
            { name: "Federation of Indian Chambers of Commerce and Industry", url: "https://ficci.in" },
            { name: "The Information System Audit and Control Association & Foundation (ISACA)", url: "https://www.isaca.org" }
          ]}
        />

        {/* SECTION 2 */}
        <Section
          title="PUBLIC FINANCIAL INSTITUTIONS"
          links={[
            { name: "Industrial Development Bank of India (IDBI)", url: "https://www.idbibank.in" },
            { name: "Industrial Finance Corporation of India (IFCI)", url: "https://www.ifciltd.com" },
            { name: "Industrial Investment Bank of India (IIBI)", url: "#" },
            { name: "Life Insurance Corporation of India (LIC)", url: "https://licindia.in" },
            { name: "Unit Trust of India (UTI)", url: "https://www.utimf.com" },
            { name: "Export Import Bank of India (Exim Bank)", url: "https://www.eximbankindia.in" },
            { name: "Housing Development Finance Corporation Ltd. (HDFC)", url: "https://www.hdfc.com" },
            { name: "National Bank for Agricultural & Rural Development (NABARD)", url: "https://www.nabard.org" },
            { name: "Housing & Urban Development Corporation (HUDCO)", url: "https://hudco.org" },
            { name: "Small Industries Development Bank of India (SIDBI)", url: "https://www.sidbi.in" }
          ]}
        />

        {/* SECTION 3 */}
        <Section
          title="INDIAN MINISTRIES, GOVERNMENT DEPARTMENTS & OTHER STATUTORY BODIES"
          links={[
            { name: "Ministry of Finance", url: "https://finmin.nic.in" },
            { name: "Ministry of Information Technology", url: "https://www.meity.gov.in" },
            { name: "Ministry of Law & Justice", url: "https://lawmin.gov.in" },
            { name: "Ministry of Home Affairs", url: "https://www.mha.gov.in" },
            { name: "Central Board of Direct Taxes", url: "https://incometaxindia.gov.in" },
            { name: "Department of Company Affairs (MCA21)", url: "https://www.mca.gov.in" },
            { name: "Central Board of Excise & Custom", url: "https://cbic.gov.in" },
            { name: "Customs, Excise and Service Tax Appellate Tribunal", url: "https://cestat.gov.in" },
            { name: "Reserve Bank of India (RBI)", url: "https://www.rbi.org.in" },
            { name: "Securities & Exchange Board of India (SEBI)", url: "https://www.sebi.gov.in" },
            { name: "National Stock Exchange (NSE)", url: "https://www.nseindia.com" },
            { name: "Bombay Stock Exchange (BSE)", url: "https://www.bseindia.com" }
          ]}
        />

      </div>
    </div>
  );
}